module.exports = __webpack_public_path__ + "static/media/canada-post.a3a6639d.svg";